import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBooks = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M.781.781c.5-.5 1.179-.78 1.886-.78h2.667A2.667 2.667 0 0 1 8 2.666v18.669a2.667 2.667 0 0 1-2.667 2.667H2.667A2.667 2.667 0 0 1 0 21.336V2.667C0 1.96.281 1.281.781.781Zm4.553 1.886H2.667v18.669h2.667V2.667Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M6.115.781c.5-.5 1.179-.78 1.886-.78h2.667a2.667 2.667 0 0 1 2.667 2.666v18.669a2.667 2.667 0 0 1-2.667 2.667H8a2.667 2.667 0 0 1-2.667-2.667V2.667c0-.707.28-1.385.781-1.886Zm4.553 1.886H8v18.669h2.667V2.667Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M0 6.668c0-.737.597-1.334 1.333-1.334h5.334a1.333 1.333 0 1 1 0 2.667H1.333A1.333 1.333 0 0 1 0 6.668Zm5.334 10.667c0-.736.597-1.333 1.333-1.333h5.334a1.333 1.333 0 0 1 0 2.667H6.667a1.333 1.333 0 0 1-1.333-1.334ZM16.296 2.67l-2.87.697-.079.024a.027.027 0 0 0-.007.008.027.027 0 0 0-.002.018L18.262 21.3l.003.006c.003.004.009.01.02.016a.12.12 0 0 0 .089.012l2.87-.697.08-.024a.028.028 0 0 0 .006-.008.027.027 0 0 0 .003-.018L16.407 2.704a.014.014 0 0 0-.003-.006.07.07 0 0 0-.02-.017.123.123 0 0 0-.09-.01Zm2.684-.674C18.58.544 17.085-.262 15.673.077l-2.915.708a1.322 1.322 0 0 0-.079.021l-.177.055a2.694 2.694 0 0 0-1.741 3.242l.003.012 4.927 17.892c.4 1.451 1.894 2.258 3.306 1.919H19l2.913-.708.078-.021.177-.055A2.693 2.693 0 0 0 23.91 19.9l-.003-.012L18.98 1.996Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M19.962 6.344a1.334 1.334 0 0 1-.97 1.617l-5.334 1.334a1.333 1.333 0 0 1-.647-2.588l5.334-1.333a1.333 1.333 0 0 1 1.617.97Zm2.565 9.361a1.333 1.333 0 0 1-.97 1.617l-5.232 1.307a1.334 1.334 0 0 1-.646-2.587l5.23-1.307a1.334 1.334 0 0 1 1.618.97Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBooks);
export default ForwardRef;
